RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.Delete = Marionette.ItemView.extend({
        template: '#adminCompanyDeleteTemplate',

        ui: {
            deleteBtn: '.x-delete'
        },

        events: {
            'click @ui.deleteBtn': 'deleteHandle'
        },

        deleteHandle: function () {
            const me = this;
            me.ui.deleteBtn.button('loading');

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    me.ui.deleteBtn.button('reset');
                    return RivalIQ.execute('alert:warning', 'An error occurred deleting this company');
                }

                App.companyDeleteModal.$el.modal('hide');
                window.location = '#/companies';
                RivalIQ.execute('alert:info', 'Company Deleted');
            });

            me.model.destroy().done(deferred.resolve).fail(deferred.reject);
        }
    });
}, RivalIQ.utils.async);
